@import "../../utils/error-message.css";

:host {
  display: block;
  font-family: var(--ls-font-family);
}

.failed-to-load-error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-style: italic;
  color: #dc2626;
  background-color: white;
  border-radius: 2px;
}

.canvas {
  position: relative;
  width: 100%;
  max-width: var(--ls-3d-scene-max-size, 500px);
  aspect-ratio: 1 / 1;
}

.canvas canvas {
  display: block;
  width: 100%;
  height: 100%;
}

.current-floor {
  top: 0;
}

.last-passed-floor {
  bottom: 0;
}

.last-update {
  position: absolute;
  bottom: 0.5rem;
  right: 0;
  font-size: var(--ls-3d-scene-last-update-size, var(--ls-text-base));
  line-height: var(
    --ls-3d-scene-last-update-line-height,
    var(--ls-line-base)
  );
  color: var(--ls-gray-600);
  background-color: var(--ls-gray-100);
  padding: var(--ls-3d-scene-last-update-padding, 0.25rem 0.5rem);
  border-radius: var(--ls-3d-scene-last-update-radius, 20px);
}
